import { SITE_URL } from './site-url';

export const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

export const ORGANIZATION_SCHEMA = {
  '@type': 'Organization' as const,
  name: 'VigorBuy Spreadsheet',
  url: SITE_URL,
  logo: FAVICON_URL,
};

export const PUBLISHER_SCHEMA = {
  '@type': 'Organization' as const,
  name: 'VigorBuy Team',
  logo: {
    '@type': 'ImageObject' as const,
    url: FAVICON_URL,
  },
};

export const WEBSITE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'VigorBuy Spreadsheet',
  url: SITE_URL,
  description: 'The ultimate resource for discovering, analyzing, and comparing VigorBuy Spreadsheet products. Updated product lists, category guides, and safe shopping strategies.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is VigorBuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'VigorBuy Spreadsheet is a structured product research resource that organizes trending products, popular categories, and essential shopping data into an easy-to-navigate format. It helps shoppers discover and compare products efficiently without spending hours searching across multiple platforms.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is VigorBuy Spreadsheet free to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, VigorBuy Spreadsheet is completely free to browse and explore. Simply navigate through the categories, explore the guides, and find what you need without any cost or subscription required.',
      },
    },
    {
      '@type': 'Question',
      name: 'How often is VigorBuy Spreadsheet updated?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The VigorBuy Spreadsheet resource is regularly refreshed to include the latest trending products and updated category information. We continuously monitor market trends to keep the data relevant.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can beginners use VigorBuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. VigorBuy Spreadsheet is designed with beginners in mind. The structured layout, clear category labels, and step-by-step guides make it easy for anyone to start exploring products right away.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is VigorBuy Spreadsheet safe?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, VigorBuy Spreadsheet is a safe resource for product research. We encourage all users to follow basic online safety practices: verify website sources, avoid sharing personal payment information, and always review product details carefully before buying.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I find products?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Finding products is simple — browse through our organized categories using the dropdown menu or category cards. Each category links to a curated collection where you can explore products, compare options, and make informed purchasing decisions.',
      },
    },
  ],
};

interface ArticleSchemaParams {
  path: string;
  headline: string;
  description: string;
  imageUrl?: string;
}

export function createArticleSchema({ path, headline, description, imageUrl }: ArticleSchemaParams) {
  const url = `${SITE_URL}${path}`;
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    author: {
      '@type': 'Organization',
      name: 'VigorBuy Team',
    },
    publisher: {
      '@type': 'Organization',
      name: 'VigorBuy Spreadsheet',
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    datePublished: '2026-07-15',
    dateModified: '2026-07-23',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    url,
  };
  if (imageUrl) {
    schema.image = imageUrl;
  }
  return schema;
}